<template>
  <router-view />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.isAdmin) {
        next('/')
        return
      }
    })
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin',
    ]),
  },
}
</script>

<style lang="scss" module>
.root {
  //
}
</style>
